import { useMutation } from '@tanstack/react-query';

import { tradingCompetitionApi } from '../../clients/clients';
import type { JoinTradingCompetitionRequest } from '../../generated';

export const useJoinTradingCompetitionMutation = () => {
  return useMutation({
    mutationKey: ['tradingCompetitionApi.joinCompetition'],
    mutationFn: async (params: JoinTradingCompetitionRequest) => {
      await tradingCompetitionApi.joinCompetition({
        joinTradingCompetitionRequest: params,
      });
    },
  });
};


